import { useTranslation } from 'react-i18next';
import useScrollReveal from '@/hooks/useScrollReveal';

export default function ContactSection() {
  const { t } = useTranslation();
  const { ref, isVisible } = useScrollReveal(0.1);

  return (
    <section id="contacto" className="py-20 md:py-28 bg-background-50 relative overflow-hidden">
      <div className="absolute inset-0 pointer-events-none select-none overflow-hidden">
        <div className="absolute top-0 right-0 w-1/2 h-full opacity-[0.03]">
          <div className="absolute right-20 top-20 w-px h-80 bg-primary-400"></div>
          <div className="absolute right-32 top-28 w-px h-64 bg-primary-400"></div>
          <div className="absolute right-20 top-28 w-12 h-px bg-primary-400"></div>
        </div>
      </div>

      <div className="relative max-w-[1200px] mx-auto px-6 md:px-10">
        <div ref={ref} className={`scroll-reveal text-center mb-14 ${isVisible ? 'visible' : ''}`}>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-900 mb-4">
            {t('contact.title')}
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            {t('contact.subtitle')}
          </p>
        </div>

        <div className="max-w-2xl mx-auto grid grid-cols-1 sm:grid-cols-2 gap-5">
          <div className="flex items-start gap-4 p-5 bg-background-100 rounded-xl">
            <div className="w-11 h-11 flex-shrink-0 flex items-center justify-center rounded-xl bg-primary-100 text-primary-500">
              <i className="ri-whatsapp-line text-xl"></i>
            </div>
            <div>
              <h4 className="font-heading text-sm font-semibold text-foreground-800 mb-1">{t('contact.whatsapp')}</h4>
              <a href="https://wa.me/50670555703" target="_blank" rel="noopener noreferrer" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors">+506 7055-5703</a>
            </div>
          </div>
          <div className="flex items-start gap-4 p-5 bg-background-100 rounded-xl">
            <div className="w-11 h-11 flex-shrink-0 flex items-center justify-center rounded-xl bg-primary-100 text-primary-500">
              <i className="ri-mail-line text-xl"></i>
            </div>
            <div>
              <h4 className="font-heading text-sm font-semibold text-foreground-800 mb-1">{t('contact.email')}</h4>
              <a href="mailto:kremsi@annayasrl.com" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors">kremsi@annayasrl.com</a>
            </div>
          </div>
          <div className="flex items-start gap-4 p-5 bg-background-100 rounded-xl">
            <div className="w-11 h-11 flex-shrink-0 flex items-center justify-center rounded-xl bg-primary-100 text-primary-500">
              <i className="ri-time-line text-xl"></i>
            </div>
            <div>
              <h4 className="font-heading text-sm font-semibold text-foreground-800 mb-1">{t('contact.hours')}</h4>
              <p className="text-sm text-foreground-500">{t('contact.hours_value')}</p>
            </div>
          </div>
          <div className="flex items-start gap-4 p-5 bg-background-100 rounded-xl">
            <div className="w-11 h-11 flex-shrink-0 flex items-center justify-center rounded-xl bg-primary-100 text-primary-500">
              <i className="ri-map-pin-line text-xl"></i>
            </div>
            <div>
              <h4 className="font-heading text-sm font-semibold text-foreground-800 mb-1">{t('contact.location')}</h4>
              <p className="text-sm text-foreground-500">{t('contact.location_value')}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}